import * as React from 'react';


const Extension = () => (
    <div className="container">
        <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12">
                <h1>Extensión de Chrome</h1>
                <p>
                    La extensión <strong>Lista Negra del SAT</strong> es una herramienta de navegador 
                    para Chrome que permite verificar rápidamente si una empresa o contribuyente se 
                    encuentra en la lista negra del Servicio de Administración Tributaria (SAT) de México.
                </p>
                <p>
                    Esta extensión facilita el proceso de consulta de la lista negra del SAT directamente 
                    desde tu navegador, sin necesidad de navegar manualmente al sitio web oficial del SAT. 
                    Es una herramienta útil para empresas y profesionales que necesitan validar el estado 
                    fiscal de sus clientes o proveedores de manera rápida y eficiente.
                </p>
                <p>
                    Puedes instalar la extensión desde la Chrome Web Store:
                </p>
                <p>
                    <a 
                        href="https://chromewebstore.google.com/detail/lista-negra-del-sat/elmegcgidollmkgnkfpajelcjmfgafok?hl=en-US&utm_source=ext_sidebar" 
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        Instalar extensión desde Chrome Web Store
                    </a>
                </p>
            </div>
        </div>
    </div>
);

export default Extension;

